<!--
/*******************************************************************************
*@ 컴포넌트명   : LoadingBar.vue
*@ 컴포넌트설명 : 로딩바 공통컴포넌트
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <div class="loading-container">
    <div class="loading-bar">
      <i class="kb-logo" />
      <svg :class="[boxRotate ? 'box-rotate': '' ]" width="60" height="60" viewBox="0 0 60 60">
        <defs>
          <path
            d="M166 45h28c8.837 0 16 7.163 16 16v28c0 8.837-7.163 16-16 16h-28c-8.837 0-16-7.163-16-16V61c0-8.837 7.163-16 16-16z"
            id="a"
          />
        </defs>
        <use fill="#FFD719" transform="rotate(90 127.5 -22.5)" xlink:href="#a" fill-rule="evenodd" />
      </svg>
      <div class="box-back"></div>
    </div>
    <p class="loading-text">KB Global</p>
  </div>
</template>
<style lang="scss"></style>
<script>
export default {
  props: {
    boxRotate: { type: Boolean, default: true },
  },
};
</script>